export default {
    routerName: 'メッセージ',
    placeholder: {
        selected: '{0}を選択してください',
        required: '{0}を入力してください',
        requiredFullWidthChar: '{0}は全角文字で入力してください',
        requiredHalfWidthChar: '{0}は半角文字で入力してください',
        requiredHalfWidthCharOrNumber: '{0}は半角英数字で入力してください',
        requiredHalfWidthNumber: '{0}は半角数字で入力してください',
        lessThen: '{0}は{1}以下の値を入力してください',
        moreThen: '{0}は{1}以上の値を入力してください',
    },
    error: {
        maxLengthFullWidth: '{0}は{1}バイト以下でなければなりません（半角文字：1バイト、全角文字：2バイト）。',
        minLengthFullWidth: '{0}は{1}バイト以上でなければなりません（半角文字：1バイト、全角文字：2バイト）。',
        betweenLengthFullWidth:
            '{0}は{1}バイト以上{2}バイト以内でなければなりません（半角文字：1バイト、全角文字：2バイト）。',
        maxLength: '{0}は{1}文字以下でなければなりません',
        minLength: '{0}は{1}文字以上でなければなりません',
        equal: '[{0}] と [{1}] が一致していません。',
        range: '{0}は{1}から{2}までの範囲でなければなりません。',
        firstChar: '{0}の頭文字が{1}でなければなりません。',
        format: '{0}は形式に誤りがあります。',
        ban: '{0}に使用禁止の文字が含まれています。',
        minus: '{0}にマイナスの値は入力できません。',
        required: '{0}を入力しなければなりません。',
        selected: '{0}を選択しなければなりません。',
        requiredFullWidthChar: '{0}は全角文字でなければなりません。',
        requiredHalfWidthChar: '{0}は半角文字でなければなりません。',
        requiredHalfWidthCharOrNumber: '{0}は半角英数字でなければなりません。',
        requiredHalfWidthNumber: '{0}は半角数字でなければなりません。',
        lessThen: '{0}は{1}以下の値でなければなりません。',
        moreThen: '{0}は{1}以上の値でなければなりません。',
    },
    action: {
        articleHistory: '履歴文章',
        name: '操作',
        search: '検索',
        add: '追加',
        show: '表示',
        hide: '隠す',
        edit: '編集',
        delete: '削除',
        deleteAll: '一括削除',
        submit: 'サブミット',
        reset: 'リセット',
        clear: 'クリア',
        random: 'ランダム',
        changePwd: 'パスワード変更',
        changePic: '画像変更',
        cancel: 'キャンセル',
        picSelect: '画像選択',
        upload: 'アップロード',
        download: 'ダウンロード',
        addSuccess: '追加に成功しました。',
        addFail: '追加に失敗しました。',
        updateSuccess: '更新に成功しました。',
        moduleUpdateSuccess: '{0}が更新に成功しました。',
        updateFail: '更新に失敗しました。',
        moduleUpdateFail: '{0}が更新に失敗しました。',
    },
    file: {
        name: 'ファイル',
        uploadImg: 'アップロード画像',
        error: {
            format: 'ファイルフォーマットが誤り。',
            typeFormat: 'ファイルフォーマットが誤り，(jpg|png|gif)フォーマットのイメージを選択してください。',
            moreThenSize: 'ファイルサイズ上限を超えました。',
            maxSize: 'ファイルサイズ上限は2Mである。',
        },
    },
    page: {
        total: '総計',
        paper: '件',
    },
    warn: {
        notSelectedRow: '一件以上のデータを選択してください。',
    },
};
